import Vue from 'vue'
import VueRouter from 'vue-router'
// Configuracion
import EmpleadosView from './views/configuraciones/Empleados.view.vue'
import UsuariosView from './views/configuraciones/accesos/usuarios.view.vue'
import RolesView from './views/configuraciones/accesos/roles.view.vue'
import PermisosView from './views/configuraciones/accesos/permisos.view.vue'
import DepartamentoView from './views/catalogo/Departamentos.view.vue'
import FormCaracteristicaView from './views/configuraciones/FormCaracteristicas.view.vue'
// CatalogosS
import DeportesView from './views/catalogo/Deportes.view.vue'
import TiposPersonalView from './views/catalogo/TiposPersonal.view.vue'
import LigasView from './views/catalogo/Ligas.view.vue'
// UUAA
import TreeView from './views/catalogo/Tree.view.vue'
import EspaciosTableView from './views/catalogo/ArbolUA/EspaciosTable.view.vue'
import DeportesTableView from './views/catalogo/ArbolUA/DeportesTable.view.vue'
import LigasTableView from './views/catalogo/ArbolUA/LigasTable.view.vue'
import EquiposTableView from './views/catalogo/ArbolUA/EquiposTable.view.vue'
import JugadoresTableView from './views/catalogo/ArbolUA/JugadoresTable.view.vue'
// import ArbolEquiposView from './views/catalogo/ejemplosarbol/ArbolEquipos.view.vue'
// import PruebaView from './views/catalogo/ejemplosarbol/Prueba.view.vue'
import ArbolView from './views/catalogo/Arbol.view.vue'
// Inventarios
// Configuraciones
import PanelEmpresaView from './views/configuraciones/procesos/PanelEmpresa.view.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: () => import(/* webpackChunkname: "login" */ './views/login.view.vue'),
      meta: {
        breadcrumb: [],
        name: ''
      }
    },
    {
      path: '/home',
      name: 'home',
      // beforeEnter
      meta: {
        allowAnonymous: true,
        breadcrumb: [{ name: 'Inicio' }],
        name: 'Sistema De Credencialización'
      },
      component: () => import(/* webpackChunkname: "Home" */ './views/home.view.vue')
    },
    // ========== Configuraciones ========== \\
    {
      path: '/Configuraciones/Empleados',
      name: 'ConfigEmpleadosView',
      meta: {
        allowAnonymous: true,
        name: 'Integrantes',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Integrantes' }]
      },
      component: EmpleadosView
    },
    {
      path: '/Configuraciones/accesos/Usuarios',
      name: 'ConfigAuthUsersView',
      meta: {
        allowAnonymous: true,
        name: 'Usuarios',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Usuarios' }]
      },
      component: UsuariosView
    },
    {
      path: '/Configuraciones/Acceso/Roles',
      name: 'ConfigAuthRolsView',
      meta: {
        allowAnonymous: true,
        name: 'Roles',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Roles' }]
      },
      component: RolesView
    },
    {
      path: '/Configuraciones/Acceso/Permisos',
      name: 'ConfigAuthPermissView',
      meta: {
        allowAnonymous: true,
        name: 'Permisos',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Acceso' }, { name: 'Permisos' }]
      },
      component: PermisosView
    },
    {
      path: '/Configuraciones/FormFamiliaCaracterristicas',
      name: 'FormCaracteristicaView',
      meta: {
        allowAnonymous: true,
        name: 'Formulario de Familia-Caracteristicas',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Formulario de Familia y Caracteristicas' }]
      },
      component: FormCaracteristicaView
    },
    // ========== Catalogos ========== \\
    // {
    //   path: '/Catalogos/ArbolEquipos',
    //   name: 'ArbolEquiposView',
    //   meta: {
    //     allowAnonymous: true,
    //     name: 'Equipos',
    //     breadcrumb: [{ name: 'Catálogos' }, { name: 'Arbol' }]
    //   },
    //   component: ArbolEquiposView
    // },
    // {
    //   path: '/Catalogos/Prueba',
    //   name: 'PruebaView',
    //   meta: {
    //     allowAnonymous: true,
    //     name: 'Equipos',
    //     breadcrumb: [{ name: 'Catálogos' }, { name: 'Arbol' }]
    //   },
    //   component: PruebaView
    // },
    {
      path: '/Catalogos/Tree/:espacioId',
      component: TreeView
    },
    {
      path: '/Catalogos/Tree',
      name: 'TreeView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [
          { name: 'UUAA' }
        ]
      },
      component: TreeView
    },
    {
      path: '/Catalogos/JugadoresTable',
      name: 'JugadoresTableView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [{ name: 'UUAA' }, { name: 'Jugadores' }]
      },
      component: JugadoresTableView
    },
    {
      path: '/Catalogos/EquiposTable/:ligasId',
      name: 'EquiposTableView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [{ name: 'UUAA' }, { name: 'Equipos' }]
      },
      component: EquiposTableView
    },
    {
      path: '/Catalogos/DeportesTable/:espacioId',
      name: 'DeportesTableView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [{ name: 'UUAA' }, { name: 'Deportes' }]
      },
      component: DeportesTableView
    },
    {
      path: '/Catalogos/LigasTable/:deportesId',
      name: 'LigasTableView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [{ name: 'UUAA' }, { name: 'Ligas' }]
      },
      component: LigasTableView
    },
    {
      path: '/Catalogos/EspaciosTable',
      name: 'EspacioTableView',
      meta: {
        allowAnonymous: true,
        name: 'Organizacion de Unidades Administrativas',
        breadcrumb: [{ name: 'UUAA' }, { name: 'Espacios' }]
      },
      component: EspaciosTableView
    },
    {
      path: '/Catalogos/Arbol',
      name: 'ArbolView',
      meta: {
        allowAnonymous: true,
        name: 'Arbol',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Arbol' }]
      },
      component: ArbolView
    },
    {
      path: '/Catalogos/Departamentos',
      name: 'DepartamentoView',
      meta: {
        allowAnonymous: true,
        name: 'UuAas',
        breadcrumb: [
          { name: 'Empresa' },
          { name: 'UuAas' }
        ]
      },
      component: DepartamentoView
    },
    {
      path: '/Catalogos/Ligas',
      name: 'LigasView',
      meta: {
        allowAnonymous: true,
        name: 'Ligas',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Ligas' }]
      },
      component: LigasView
    },
    {
      path: '/Catalogos/Deportes',
      name: 'DeportesView',
      meta: {
        allowAnonymous: true,
        name: 'Deportes',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Deportes' }]
      },
      component: DeportesView
    },
    {
      path: '/Catalogos/TiposPersonal',
      name: 'TiposPersonalView',
      meta: {
        allowAnonymous: true,
        name: 'Tipos De Personal',
        breadcrumb: [{ name: 'Catálogos' }, { name: 'Personal' }]
      },
      component: TiposPersonalView
    },
    // ============================================================== \\
    // ============================================================== \\
    // ============================================================== \\
    // Mesa de ayuda \\
    // Catalogos \\
    {
      path: '/Catalogo/Roles/Permisos/:id',
      name: 'ViewPermissionsRoleAssign',
      meta: {
        allowAnonymous: true,
        name: 'Asignar Permisos a Rol',
        breadcrumb: [
          { name: 'Catalogo' },
          { name: 'Roles' },
          { name: 'Asignacion de Permisos' }
        ]
      },
      component: () => import('./views/company/rolePermissionsAssign.view.vue')
    },
    // Inventarios \\

    // {
    //   path: '/Inventarios/Proveedores',
    //   name: 'InvProveedores',
    //   meta: {
    //     allowAnonymous: true,
    //     breadcrumb: [
    //       { name: 'Inventarios' },
    //       { name: 'Proveedores' }
    //     ]
    //   },
    //   component: () => import('./views/inventarios/proveedores.view.vue')
    // },
    // Configuraciones \\
    {
      path: '/Configuraciones/TiposProcesos',
      name: 'ViewProcesos',
      meta: {
        allowAnonymous: true,
        name: 'Tipos de Procesos',
        breadcrumb: [
          { name: 'Configuraciones' },
          { name: 'Tipos de Procesos' }
        ]
      },
      component: () => import('./views/company/configuraciones/procesos.view.vue')
    },
    {
      path: '/Configuraciones/RutinasProcesos/PanelEmpresa',
      name: 'ConfigRutProcPanelEmpresa',
      meta: {
        allowAnonymous: true,
        name: 'Panel de Datos de Empresa',
        breadcrumb: [{ name: 'Configuraciones' }, { name: 'Rutinas y Procesos' }, { name: 'Panel de Empresa' }]
      },
      component: PanelEmpresaView
    }
    // Fin Configuraciones Fin \\
  ]
})
